import { combineReducers } from 'redux';

import { autoCompleteLanguagesReducer } from 'features/AllowedAutoCompleteLanguagesFeature';
import { allowedEntryLanguagesReducer } from 'features/AllowedEntryLanguagesFeature';
import { allowedUiLanguageReducer } from 'features/AllowedUiLanguagesFeature';
import { cultureCodeReducer } from 'features/CultureCodeFeature';
import { languageReducer } from 'features/LanguagesFeature';
import { userReducer } from 'features/UserFeature';
import { userSettingsReducer } from 'features/UserSettingsFeature';

export const rootReducer = combineReducers({
	allowedAutoCompleteLanguages: autoCompleteLanguagesReducer,
	allowedEntryLanguages: allowedEntryLanguagesReducer,
	allowedUiLanguages: allowedUiLanguageReducer,
	cultureCode: cultureCodeReducer,
	languages: languageReducer,
	user: userReducer,
	userSettings: userSettingsReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
